import { Component, EventEmitter, Input, OnInit, Output, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {AspCheckinReportsService} from './asp-checkin-reports.service'
import { HttpClient } from '@angular/common/http';
import { GlobalVariable } from 'app/main/globals';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import domtoimage from 'dom-to-image-more';



@Component({
  selector: 'app-asp-checkin-reports',
  templateUrl: './asp-checkin-reports.component.html',
  styleUrls: ['./asp-checkin-reports.component.scss']
})
export class AspCheckinReportsComponent implements OnInit {
  isBottomSheetOpen= false;
  currentPage: number = 1;
  totalPages: number = 2; 
  images: string[] = [];

  @Input() bookingId!: string;
  @Input() jobCard!: string;
  @Input() jobCardStatus! : string;

 @ViewChild('bottomSheetTemplate') bottomSheetTemplate!: TemplateRef<any>;
  data: any;
  accessories: any;
  accessoriesYes: any;
  damageImages: any;
  fuelMeterImage: any;
  isAccept: boolean;
  successIcon: any = '../../../../assets/icons/icons8-ok.gif';
  Accepted: boolean;
  popupOpen: boolean;
  rejected: boolean;
  jobCardStatusPass: number;
  rejectedPopup: boolean;
  constructor(
     private bottomSheet: MatBottomSheet,
     private renderer: Renderer2,
     private AspCheckinReportsService:AspCheckinReportsService,
     private http: HttpClient,
     private aspLoadingService: AspLoadingService,
     
  ) { }

  ngOnInit(): void {
    console.log('bookingId ID:', this.bookingId);
    console.log('jobCard ID:', this.jobCard);
    console.log('jobCardStatus:', this.jobCardStatus);
    this.checkInDetails();
  }

  @Output() changeTab = new EventEmitter<string>();

  openInformationTab() {
    this.changeTab.emit('Information'); 
    this.closeBottomSheet();
  }
  openMenu() {
    this.isBottomSheetOpen = true;
    
  }
   closeMenu(): void {
    this.isBottomSheetOpen = false;
  }
  openBottomSheet(): void {
    this.bottomSheet.open(this.bottomSheetTemplate,{
     panelClass: 'bottom-sheet-checkin'
    }
    );
  }
  closeBottomSheet(): void {
    if (this.bottomSheet) {
      this.bottomSheet.dismiss();
    }
  }
 
  // shareWithCustomer(): void {
  //   const spareSelectedGarageName= localStorage.getItem('spareSelectedGarageName');
  //   let garageKey = localStorage.getItem('garageKey');
  //   const combinedPath = `${this.jobCard}/${this.bookingId}/${garageKey}`;
  //   const encodedPath = btoa(combinedPath);
  //   const message = `Hello *${this.data.customerName}*, \n\n Your *Job Card ID:${this.jobCard}*. \n Here is your vehicle check-in report. ${GlobalVariable.AUTOVERSE_WEB}/checkin/${encodedPath} \n\n A quotation will be shared with you shortly for approval. \n\n *Regards*,\n${spareSelectedGarageName}`;
   
  //   // WhatsApp API or Intent to share
  //   window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');

  //   this.closeMenu();
  // }

  // Go to the next page
  shareWithCustomer(): void {
  const spareSelectedGarageName = localStorage.getItem('spareSelectedGarageName');
  const garageKey = localStorage.getItem('garageKey');
  const combinedPath = `${this.jobCard}/${this.bookingId}/${garageKey}`;
  const encodedPath = btoa(combinedPath);

  const customerName = this.data?.customerName || 'Customer';
  const customerMobile = this.data?.customerMobile; // 👈 make sure you have this
  if (!customerMobile) {
    console.error('Customer mobile number not found');
    return;
  }

  const messageLink = `/checkin/${encodedPath}`;
  const carDetails = `${this.data?.make} ${this.data?.model} - ${this.data?.fuelType} - ${this.data?.variant} - ${this.data?.year}`;


  // Construct message payload
  const messagePayload = {
    v1: spareSelectedGarageName,                        // garage name
    v2: String(this.jobCard),                                   // job card id
    v3: carDetails,                                   
    v4: this.data?.registrationNumber,               
    v5: customerName, 
    id: messageLink,
    to: customerMobile  ,     
    // "v1": "Laksh Auto Garage",
    // "v2": "415678",
    // "v3": "Maruti Suzuki Alto - Petrol - Lxi - 2014",
    // "v4": "KA01MF9999",
    // "v5": "Air Filter(1), Oil Filter(2), Coolant(1), Engine Oil(3.5l)",
    // "to": ""                        
  };

  // Send via WhatsApp API
  this.AspCheckinReportsService.sendWhatsAppMessage('checkinDetails', messagePayload).subscribe(
    res => {
      console.log('WhatsApp message sent', res);
      this.closeMenu();
    },
    err => {
      console.error('Failed to send WhatsApp message', err);
    }
  );
}
  goToNextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  // Go to the previous page
  goToPreviousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }
 
async downloadPDF(): Promise<void> {
  this.aspLoadingService.show();
  const originalPage = this.currentPage;
  this.currentPage = 0;

  const pages = ['page1', 'page2', 'page3', 'page4', 'page5'];
  const doc = new jsPDF('p', 'mm', 'a4');

  const marginTop = 10;
  const marginLeft = 2;
  const marginRight = 2;
  const pdfWidth = doc.internal.pageSize.getWidth();
  const pdfHeight = doc.internal.pageSize.getHeight();
  const usableWidth = pdfWidth - marginLeft - marginRight;

  for (let i = 0; i < pages.length; i++) {
    const element = document.getElementById(pages[i]);
    if (element) {
      // 👉 Temporarily add export-only class
      element.classList.add('pdf-export-mode');

      try {
        const dataUrl = await domtoimage.toPng(element, {
          quality: 1,
          cacheBust: true,
        });

        const img = new Image();
        img.src = dataUrl;

        await new Promise<void>((resolve) => {
          img.onload = () => resolve();
        });

        const imgWidth = usableWidth;
        const imgHeight = (img.height * imgWidth) / img.width;

        if (i > 0) doc.addPage();

        doc.addImage(
          dataUrl,
          'PNG',
          marginLeft,
          marginTop,
          imgWidth,
          imgHeight > pdfHeight ? pdfHeight - 20 : imgHeight
        );
      } catch (error) {
        console.error(`Error capturing page ${pages[i]}:`, error);
      } finally {
        // 👉 Clean up export-only class
        element.classList.remove('pdf-export-mode');
      }
    }
  }

  doc.save('CheckInReport.pdf');
  this.aspLoadingService.hide();
  this.currentPage = originalPage;
  this.aspLoadingService.hide();
}

  
  
  
  private waitForImagesToLoad(): Promise<void> {
  const images = Array.from(document.images);
  const promises = images.map((img) => {
    if (img.complete && img.naturalHeight !== 0) return Promise.resolve();
    return new Promise<void>((resolve) => {
      img.onload = () => resolve();
      img.onerror = () => resolve();
    });
  });
  return Promise.all(promises).then(() => {});
}
  
  checkInDetails(){
    let userKey = localStorage.getItem('spareUserKey');
    let garageKey = localStorage.getItem('garageKey');
    this.AspCheckinReportsService.checkInDetails(garageKey, userKey, this.bookingId, this.jobCard).subscribe(
      result => {
        const res = JSON.parse(JSON.stringify(result));
        console.log("checkinreport-response",result);
        this.data = res['data'];
        this.accessoriesYes = res['data'].accessories;
        this.damageImages = this.data.damageImages;
        this.images= this.data.images;
        this.fuelMeterImage = this.data.fuelMeterImage;
        console.log("Data structure:", this.data); // Check the whole structure of data
        console.log("fuelMeterImage in response:", this.data?.fuelMeterImage); // Check if fuelMeterImage is nested
        // Sort accessoriesImages in ascending order based on tag numbers
        if (this.data.accessoriesImages) {
          this.data.accessoriesImages.sort((a, b) => {
            const numA = parseInt(a.tag.replace('accessories_', ''), 10);
            const numB = parseInt(b.tag.replace('accessories_', ''), 10);
            return numA - numB;
          });
        }

      }
    );
    // this.getAccessoriesList();
}

// getAccessoriesList(){
//   this.AspCheckinReportsService.getAccessoriesList().subscribe(
//     res => {
//       console.log("res", res);
//       this.accessories = res['data'].accessories;

//       // After getting the full list of accessories, match with the "Yes" accessories
//       this.accessories.forEach(item => {
//         // Check if this item is in the accessoriesYes list by comparing the description
//         item.isYes = this.accessoriesYes.some(yesItem => yesItem === item.description);
//       });

//       console.log(this.accessories); // Check the updated list
//     }
//   );
// }
Accept(){
  this.isAccept=!this.isAccept;
  this.Accepted=true;
  this.acceptReject()
}
acceptPopup(){
  this.isAccept=false;
  window.location.reload();
}
reject(){
  this.popupOpen=true;
}
closePopup(){
  this.popupOpen=false;
}
rejectedYes(){
  this.rejectedPopup=true;
  this.popupOpen=false;
  this.rejected=true;
  this.acceptReject();
}
popupRejected(){
  this.rejectedPopup=false;
  window.location.reload();
}

acceptReject(){

  let garageKey = localStorage.getItem('garageKey');
  if (this.Accepted== true) {
    this.jobCardStatusPass= 2;
  }
  if (this.rejected==true) {
    this.jobCardStatusPass= 0;
  }
  this.AspCheckinReportsService.acceptReject( this.bookingId, this.jobCard, garageKey, this.jobCardStatusPass).subscribe(
    result => { 
      console.log("result",result);
      this.jobCardStatus= result['data'].JobCardStatus;
      
     
    })
}
shareForApproval(): void {
    let garageKey = localStorage.getItem('garageKey');
    this.jobCardStatusPass= 1;
  this.AspCheckinReportsService.acceptReject( this.bookingId, this.jobCard, garageKey, this.jobCardStatusPass).subscribe(
    result => { 
      console.log("result",result);
      this.jobCardStatus= result['data'].JobCardStatus;
      console.log("jobCardStatus",this.jobCardStatus);
      let garageName = localStorage.getItem('spareSelectedGarageName');
    let garageKey = localStorage.getItem('garageKey');
    const combinedPath = `${this.jobCard}/${this.bookingId}/${garageKey}`;
    const encodedPath = btoa(combinedPath);
      // const message = `🚗 Hello ${this.data?.customerName},\n\nYour *Job Card ID: ${this.jobCard}* is ready!\nHere is your vehicle check-in report.\n\n👉 *Click here to accept the job card:* ${GlobalVariable.AUTOVERSE_WEB}/checkin/${encodedPath} 👈\n\nOnce accepted, we’ll send you the quotation for approval.\n\n *Regards,*\n${garageName}`;
 const carDetails = `${this.data?.make} ${this.data?.model} - ${this.data?.fuelType} - ${this.data?.variant} - ${this.data?.year}`;
  const messageLink = `/checkin/${encodedPath}`;
  // WhatsApp API or Intent to share
  // window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');
    const messagePayload = {
    v1: garageName,                        // garage name
    v2: String(this.jobCard),                                   // job card id
    v3: carDetails,                                   
    v4: this.data?.registrationNumber,               
    v5: '', 
    id: messageLink,
    to: this.data?.customerMobile                     
  };

  // Send via WhatsApp API
  this.AspCheckinReportsService.sendWhatsAppMessage('checkinApproval', messagePayload).subscribe(
    res => {
      console.log('WhatsApp message sent', res);
      this.closeMenu();
    },
    err => {
      console.error('Failed to send WhatsApp message', err);
    }
  );

      // window.location.reload();
    })
}
}
